import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Grid, Box, TextField, Slider, CircularProgress, Card, Tooltip, Checkbox } from '@mui/material';
import SFAccuracyGoalChart from './SFGoalSlider';
import SFGoalSlider from './SFGoalSlider';
import { IoIosCloseCircleOutline } from "react-icons/io";
import ApiRequestService from '../../../../components/ApiRequestService';
import { toast } from 'react-toastify';
import "./goalDialogStyle.css"
import SFInfoIcon from './SFInfoIcon';
import { FaCheckCircle, FaUndo } from 'react-icons/fa';


const SFGoalDialog = ({ open, quizID, handleClose, categoriesData, handleSaveGoalForCategories, practiceCount }) => {

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showSaved, setShowSaved] = useState(false);

    useEffect(() => {
        if (categoriesData && categoriesData.length) {
            let newCategories = categoriesData.map((cat, index) => {
                return {
                    ...cat,
                    selected: cat.isAccuracyGoalSet || cat.isTimeGoalSet || false,
                }
            })
            setCategories(newCategories);
        }
    }, [])

    useEffect(() => {
        if (showSaved) {
            const timer = setTimeout(() => {
                setShowSaved(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [showSaved]);

    const handleAccuracyGoalChange = (newGoal, index) => {
        let updatedCategories = categories.map((category, i) =>
            i === index ? { ...category, accuracyGoal: newGoal } : category
        );


        setCategories(updatedCategories);
        handleSetAccuracyGoal(updatedCategories);
    }

    const handleTimeGoalChange = (newGoal, index) => {
        let updatedCategories = categories.map((category, i) =>
            i === index ? { ...category, timeGoal: newGoal } : category
        );


        setCategories(updatedCategories);
        handleSetTimeGoal(updatedCategories);
    }

    const handleSetAccuracyGoal = (updatedCategories) => {
        if (quizID === null || quizID === undefined) {
            return
        }
        let category = updatedCategories[selectedCategoryIndex];
        updatedCategories[selectedCategoryIndex].isAccuracyGoalSet = true;
        let payload = {
            quizID: quizID,
            practiceCount: practiceCount,
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            quizID: quizID,
            accuracyGoal: category.accuracyGoal,
        }

        ApiRequestService({
            method: 'post',
            url: '/setAccuracyGoal',
            data: payload
        }).then(res => {
            setShowSaved(true);
            setSelectedCategory(updatedCategories[selectedCategoryIndex]);
            handleSaveGoalForCategories(updatedCategories)
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSetTimeGoal = (updatedCategories) => {
        if (quizID === null || quizID === undefined) {
            return
        }
        let category = updatedCategories[selectedCategoryIndex];
        updatedCategories[selectedCategoryIndex].isTimeGoalSet = true;
        let payload = {
            quizID: quizID,
            practiceCount: practiceCount,
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            quizID: quizID,
            timeGoal: parseInt(category.timeGoal),
        }

        ApiRequestService({
            method: 'post',
            url: '/setTimeGoal',
            data: payload
        }).then(res => {
            setShowSaved(true);
            setSelectedCategory(updatedCategories[selectedCategoryIndex]);
            handleSaveGoalForCategories(updatedCategories)
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSaveGoal = (updatedCategories) => {
        if (quizID === null || quizID === undefined) {
            return
        }
        let category = updatedCategories[selectedCategoryIndex];
        let payload = {
            quizID: quizID,
            practiceCount: practiceCount,
            categoryGoals: [
                {
                    catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
                    quizID: quizID,
                    accuracyGoal: category.accuracyGoal,
                    timeGoal: parseInt(category.timeGoal),
                }
            ]
        }

        setShowSaved(false);
        setLoading(true);

        ApiRequestService({
            method: 'post',
            url: '/setGoals',
            data: payload
        }).then(res => {
            setShowSaved(true);
            setSelectedCategory(updatedCategories[selectedCategoryIndex]);
            handleSaveGoalForCategories(updatedCategories)
        }).finally(() => {
            setLoading(false);
        })

    }

    const handleSelectCategory = (catIndex) => {
        let updatedCategories = categories.map((cat, index) => {
            let selected = cat.selected;
            if (catIndex === index) {
                selected = cat.isAccuracyGoalSet || cat.isTimeGoalSet || !cat.selected;
            }
            return {
                ...cat,
                selected
            }
        });
        setCategories(updatedCategories);
    }

    const handleResetAccuracyGoal = (catIndex) => {

        let updatedCategories = categories.map((category, i) =>
            i === catIndex ? {
                ...category,
                accuracyGoal: category.defaultAccuracyGoal,
                isAccuracyGoalSet: false,
            } : category
        );
        setCategories(updatedCategories);

        let category = updatedCategories[selectedCategoryIndex];
        let payload = {
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            practiceCount: practiceCount,
            quizID: quizID,
        }

        ApiRequestService({
            method: 'post',
            url: '/resetAccuracyGoal',
            data: payload
        }).then(res => {
            setShowSaved(true);
            setSelectedCategory(updatedCategories[selectedCategoryIndex]);
            handleSaveGoalForCategories(updatedCategories)
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleResetTimeGoal = (catIndex) => {

        let updatedCategories = categories.map((category, i) =>
            i === catIndex ? {
                ...category,
                timeGoal: category.defaultTimeGoal,
                isTimeGoalSet: false,
            } : category
        );
        setCategories(updatedCategories);

        let category = updatedCategories[selectedCategoryIndex];
        let payload = {
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            practiceCount: practiceCount,
            quizID: quizID,
        }

        ApiRequestService({
            method: 'post',
            url: '/resetTimeGoal',
            data: payload
        }).then(res => {
            setShowSaved(true);
            setSelectedCategory(updatedCategories[selectedCategoryIndex]);
            handleSaveGoalForCategories(updatedCategories)
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Dialog fullWidth
            maxWidth='lg'
            // fullScreen
            PaperProps={{
                sx: {
                    minHeight: '640px'
                }
            }}
            open={true}>
            <DialogTitle>
                <div className='d-flex justify-content-between align-items-end'>
                    <Grid container>
                        <Grid item md={3}>
                            <div className='d-flex align-items-center'>
                                <div style={{ width: '40px', height: '10px', background: '#FAA201' }}></div>
                                <Typography className='ml-2' >
                                    Previous Attempt Progress
                                </Typography>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div style={{ width: '40px', height: '5px', borderRadius: '4px', background: '#BA0C2F' }}></div>
                                <Typography className='ml-2'>
                                    Goal for this assignment
                                </Typography>
                            </div>

                        </Grid>
                        <Grid item md={6} xs={12} sm={12}>
                            <div className='w-100 d-flex justify-content-center'>
                                <Typography className='header-text' color={'primary'} sx={{ fontSize: '24px', textAlign: 'center', fontWeight: '600' }}>Set Your Accuracy and Time Goals</Typography>
                            </div>
                        </Grid>
                        <Grid item md={3} className='d-flex justify-content-end align-items-center'>
                            <div className='mr-5'>
                                {loading ? <span><CircularProgress size={12} /> <small>Updating goal..</small> </span> : (showSaved ? <small style={{
                                    color: '#80C75B'
                                }}> <FaCheckCircle color='#80C75B' /> Goal updated</small> : null)}
                            </div>
                        </Grid>
                    </Grid>
                    <div className='close-icon-btn'>
                        <IconButton onClick={handleClose}>
                            <IoIosCloseCircleOutline fontSize={26} fontWeight={600} color='#000' />
                        </IconButton>
                    </div>

                </div>
            </DialogTitle>
            <DialogContent>
                <div className=''>
                    <div className='sf-goal-categories py-2'>
                        {categories.map((cat, catIndex) => {
                            return (
                                <Box
                                    onClick={(e) => {
                                        setSelectedCategoryIndex(catIndex);
                                        handleSelectCategory(catIndex);
                                    }}
                                    key={catIndex} boxShadow={cat.selected ? 4 : 0}
                                    className="w-100 d-flex justify-content-center align-items-center all-cat-card position-relative"
                                    sx={{
                                        borderRadius: '12px',
                                        backgroundColor: cat.selected ? 'white' : '#DFDFDF',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: cat.selected ? '#bb0000' : '#bb0000',
                                        },
                                    }}
                                >
                                    <Grid columnSpacing={4} rowSpacing={2} container className='h-100 w-100' justifyContent={'center'} alignItems={'center'}>
                                        <Grid item md={4} xs={12}>
                                            <div className='px-2 text-align-center d-flex justify-content-start align-items-center'>
                                                <Checkbox
                                                    onClick={(e) => {
                                                        setSelectedCategoryIndex(catIndex);
                                                        handleSelectCategory(catIndex);
                                                    }}
                                                    checked={cat.selected}
                                                />
                                                <Typography className='text-align-left'>{cat.category_name}</Typography>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} xs={12} >
                                            <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                gap: '0.5rem'
                                            }}>
                                                <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                                    <div className='d-flex justify-content-center align-items-center' style={{
                                                        gap: '0.3rem'
                                                    }}>
                                                        <SFInfoIcon helpText={"Percent of questions answered correctly. Default goal is 100%"} />
                                                        <div>Accuracy %</div>
                                                        {cat.isAccuracyGoalSet ?
                                                            <div>
                                                                {/* <Tooltip
                                                                    title={
                                                                        <Typography fontSize={12} color='#fff'>
                                                                            You have set the goal for this category.
                                                                        </Typography>
                                                                    }
                                                                    placement='top'>
                                                                    <div className='ml-2'>
                                                                        <FaCheckCircle fontSize={12} color='green' />
                                                                    </div>
                                                                </Tooltip> */}

                                                                <Tooltip
                                                                    title={
                                                                        <Typography fontSize={12} color='#fff'>
                                                                            Reset to default accuracy goal
                                                                        </Typography>
                                                                    }
                                                                    placement='top'>
                                                                    <div className='goal-reset-btn'>
                                                                        <IconButton
                                                                            disabled={!cat.is_selected}
                                                                            size='small'
                                                                            color='primary'
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleResetAccuracyGoal(catIndex)
                                                                            }}>
                                                                            <FaUndo />
                                                                        </IconButton>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                            : null}
                                                    </div>
                                                </Typography>
                                                <div className='position-relative w-100'>
                                                    <SFGoalSlider
                                                        handleGoalChange={(goal) => {
                                                            handleAccuracyGoalChange(goal, catIndex)
                                                        }}
                                                        disabled={!cat.selected}
                                                        min={0}
                                                        max={100}
                                                        step={10}
                                                        goal={cat.accuracyGoal}
                                                        previousGoal={cat.previousAccuracyGoal}
                                                    />
                                                </div>
                                                <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                    <TextField
                                                        style={{ width: "50px" }}
                                                        type='number'
                                                        disabled={!cat.selected}
                                                        className='sf-goal-input no-spinner'
                                                        size='small'
                                                        inputProps={{ style: { textAlign: 'right' } }}
                                                        onChange={event => {
                                                            let val = event.target.value;
                                                            if (val > 100) {
                                                                val = 100;
                                                            }
                                                            handleAccuracyGoalChange(val, catIndex)
                                                        }}
                                                        value={cat.accuracyGoal}
                                                    />
                                                    <div className='ml-1' style={{ fontWeight: '600' }}>%</div>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                gap: '0.5rem'
                                            }}>
                                                <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                                    <div className='d-flex justify-content-center align-items-center' style={{
                                                        gap: '0.3rem'
                                                    }}>
                                                        <SFInfoIcon helpText={"Total time taken to complete this category. Default goal is median time for this semester"} /> <div>Time Taken (min)</div>
                                                        {cat.isTimeGoalSet ?
                                                            <div>
                                                                {/* <Tooltip
                                                                    title={
                                                                        <Typography fontSize={12} color='#fff'>
                                                                            You have set the goal for this category.
                                                                        </Typography>
                                                                    }
                                                                    placement='top'>
                                                                    <div className='ml-2'>
                                                                        <FaCheckCircle fontSize={12} color='green' />
                                                                    </div>
                                                                </Tooltip> */}

                                                                <Tooltip
                                                                    title={
                                                                        <Typography fontSize={12} color='#fff'>
                                                                            Reset to default time  goal
                                                                        </Typography>
                                                                    }
                                                                    placement='top'>
                                                                    <div className='goal-reset-btn'>
                                                                        <IconButton
                                                                            size='small'
                                                                            color='primary'
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleResetTimeGoal(catIndex)
                                                                            }}>
                                                                            <FaUndo />
                                                                        </IconButton>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                            : null}
                                                    </div>
                                                </Typography>
                                                <div className='position-relative w-100'>
                                                    <SFGoalSlider
                                                        type="time"
                                                        handleGoalChange={(goal) => {
                                                            handleTimeGoalChange(goal, catIndex)
                                                        }}
                                                        disabled={!cat.selected}
                                                        min={0}
                                                        max={10}
                                                        step={1}
                                                        goal={cat.timeGoal}
                                                        previousGoal={cat.previousTimeGoal / 60}
                                                    />
                                                </div>
                                                <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                    <TextField
                                                        type='number'
                                                        style={{ width: "50px" }}
                                                        disabled={!cat.selected}
                                                        className='sf-goal-input no-spinner'
                                                        size='small'
                                                        inputProps={{ style: { textAlign: 'right' } }}
                                                        onChange={event => {
                                                            let val = event.target.value;
                                                            handleTimeGoalChange(val, catIndex)
                                                        }}
                                                        value={cat.timeGoal}
                                                    />
                                                    <div className='ml-1' style={{ fontWeight: '600' }}>min</div>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )
                        })}
                    </div>

                    {/* <div className='d-flex justify-content-start px-4 pt-2' style={{ height: '100px', gap: '1rem', overflowX: 'auto', }}>
                        <div
                            onClick={() => {
                                setSelectedCategory(null);
                                setSelectedCategoryIndex(-1);
                            }}
                            className="d-flex cursor-pointer justify-content-center align-items-center" style={{
                                minWidth: '160px',
                                maxWidth: '160px',
                                height: '70px', width: '160px', borderRadius: '12px',
                                border: selectedCategoryIndex === -1 ? "2px solid #fff" : "1px solid #bfc6cb",
                                background: selectedCategoryIndex === -1 ? "#bb0000" : "white",
                                color: selectedCategoryIndex === -1 ? "#fff" : "black",
                                boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.25)'
                            }}>
                            All Categories
                        </div>
                        {categories.map((cat, catIndex) => {
                            return (
                                <div
                                    onClick={() => {
                                        setSelectedCategory(cat);
                                        setSelectedCategoryIndex(catIndex);
                                    }}
                                    key={catIndex} className="cat-list-card d-flex text-center cursor-pointer justify-content-center align-items-center"
                                    style={{
                                        minWidth: '160px',
                                        maxWidth: '160px',
                                        height: '70px',
                                        borderRadius: '12px',
                                        border: selectedCategoryIndex === catIndex ? "2px solid #fff" : "1px solid #bfc6cb",
                                        background: selectedCategoryIndex === catIndex ? "#bb0000" : "white",
                                        color: selectedCategoryIndex === catIndex ? "#fff" : "black",
                                        boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.25)'
                                    }}>
                                    {cat.category_name}
                                </div>
                            )
                        })}
                    </div> */}

                    {/*                     {selectedCategoryIndex !== -1 ?
                        <div>
                            <Grid spacing={4} container justifyContent={'center'} alignItems={'center'}>
                                <Grid item md={5} xs={12}>
                                    <Card variant='outlined' className='position-relative d-flex flex-column justify-content-around align-items-center px-4 single-cat-card' style={{
                                        gap: '0.5rem',
                                        boxShadow: '2px 2px 15px 0px rgba(0, 0, 0, 0.25)',
                                        height: '250px'
                                    }}>
                                        <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                            <div className='d-flex'>
                                                <SFInfoIcon helpText={"Percent of questions answered correctly. Default goal is 100%"} /> <div>Accuracy %</div>
                                            </div>
                                        </Typography>
                                        <div className='position-relative w-100'>
                                            <SFGoalSlider
                                                handleGoalChange={(goal) => {
                                                    handleAccuracyGoalChange(goal, selectedCategoryIndex)
                                                }}
                                                min={0}
                                                max={100}
                                                step={10}
                                                goal={selectedCategory.accuracyGoal}
                                                previousGoal={selectedCategory.previousAccuracyGoal}
                                            />
                                        </div>
                                        <div className='mt-2 d-flex justify-content-center align-items-center'>
                                            <TextField
                                                style={{ width: "50px" }}
                                                type='number'
                                                className='sf-goal-input no-spinner'
                                                size='small'
                                                inputProps={{ style: { textAlign: 'right' } }}
                                                onChange={event => {
                                                    let val = event.target.value;
                                                    let valInt = parseInt(val);
                                                    if (valInt > 100) {
                                                        valInt = 100;
                                                    }
                                                    handleAccuracyGoalChange(valInt, selectedCategoryIndex)
                                                }}
                                                value={selectedCategory.accuracyGoal}
                                            // placeholder='Enter Goal (%)'
                                            />
                                            <div className='ml-2' style={{ fontWeight: '600' }}>%</div>
                                        </div>
                                    </Card>
                                </Grid>
                                <Grid item md={5} xs={12}>
                                    <Card variant='outlined' className='position-relative d-flex flex-column justify-content-around align-items-center px-4 single-cat-card' style={{
                                        gap: '0.5rem',
                                        boxShadow: '2px 2px 15px 0px rgba(0, 0, 0, 0.25)',
                                        height: '250px'
                                    }}>
                                        <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                            <div className='d-flex'>
                                                <SFInfoIcon helpText={"Total time taken to complete this category. Default goal is median time for this semester"} /> <div>Time Taken (min)</div>
                                            </div>
                                        </Typography>
                                        <div className='position-relative w-100'>
                                            <SFGoalSlider
                                                type="time"
                                                handleGoalChange={(goal) => {
                                                    handleTimeGoalChange(goal, selectedCategoryIndex)
                                                }}
                                                min={0}
                                                max={10}
                                                step={1}
                                                goal={selectedCategory.timeGoal}
                                                previousGoal={selectedCategory.previousTimeGoal / 60}
                                            />
                                        </div>
                                        <div className='mt-2 d-flex justify-content-center align-items-center'>
                                            <TextField
                                                type='number'
                                                style={{ width: "50px" }}
                                                className='sf-goal-input no-spinner'
                                                size='small'
                                                inputProps={{ style: { textAlign: 'right' } }}
                                                onChange={event => {
                                                    let val = event.target.value;
                                                    handleTimeGoalChange(parseInt(val), selectedCategoryIndex)
                                                }}
                                                value={selectedCategory.timeGoal}
                                            // placeholder='Enter Goal (%)'
                                            />
                                            <div className='ml-2' style={{ fontWeight: '600' }}>min</div>
                                        </div>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                        :
                        <div className='sf-goal-categories py-2'>
                            {categories.map((cat, catIndex) => {
                                return (
                                    <Box key={catIndex} boxShadow={4} className="w-100 d-flex justify-content-center align-items-center all-cat-card" style={{ borderRadius: '12px' }}>
                                        <Grid columnSpacing={4} rowSpacing={2} container className='h-100 w-100' justifyContent={'center'} alignItems={'center'}>
                                            <Grid item md={4} xs={12}>
                                                <div className='px-2 text-align-center d-flex justify-content-center align-items-center'>
                                                    <Typography>{cat.category_name}</Typography>
                                                </div>
                                            </Grid>
                                            <Grid item md={4} xs={12} >
                                                <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                    gap: '0.5rem'
                                                }}>
                                                    <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                                        <div className='d-flex'>
                                                            <SFInfoIcon helpText={"Percent of questions answered correctly. Default goal is 100%"} /> 
                                                            <div>Accuracy %</div>
                                                        </div>
                                                    </Typography>
                                                    <div className='position-relative w-100'>
                                                        <SFGoalSlider
                                                            handleGoalChange={(goal) => {
                                                                handleAccuracyGoalChange(goal, catIndex)
                                                            }}
                                                            min={0}
                                                            max={100}
                                                            step={10}
                                                            goal={cat.accuracyGoal}
                                                            previousGoal={cat.previousAccuracyGoal}
                                                        />
                                                    </div>
                                                    <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                        <TextField
                                                            style={{ width: "50px" }}
                                                            type='number'
                                                            className='sf-goal-input no-spinner'
                                                            size='small'
                                                            inputProps={{ style: { textAlign: 'right' } }}
                                                            onChange={event => {
                                                                let val = event.target.value;
                                                                if (val > 100) {
                                                                    val = 100;
                                                                }
                                                                handleAccuracyGoalChange(val, catIndex)
                                                            }}
                                                            value={cat.accuracyGoal}
                                                        />
                                                        <div className='ml-2' style={{ fontWeight: '600' }}>%</div>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                    gap: '0.5rem'
                                                }}>
                                                    <Typography className='my-1' textAlign={'center'} fontWeight={600}>
                                                        <div className='d-flex'>
                                                            <SFInfoIcon helpText={"Total time taken to complete this category. Default goal is median time for this semester"} /> <div>Time Taken (min)</div>
                                                        </div>
                                                    </Typography>
                                                    <div className='position-relative w-100'>
                                                        <SFGoalSlider
                                                            type="time"
                                                            handleGoalChange={(goal) => {
                                                                handleTimeGoalChange(goal, catIndex)
                                                            }}
                                                            min={0}
                                                            max={10}
                                                            step={1}
                                                            goal={cat.timeGoal}
                                                            previousGoal={cat.previousTimeGoal / 60}
                                                        />
                                                    </div>
                                                    <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                        <TextField
                                                            type='number'
                                                            style={{ width: "50px" }}
                                                            className='sf-goal-input no-spinner'
                                                            size='small'
                                                            inputProps={{ style: { textAlign: 'right' } }}
                                                            onChange={event => {
                                                                let val = event.target.value;
                                                                handleTimeGoalChange(val, catIndex)
                                                            }}
                                                            value={cat.timeGoal}
                                                        />
                                                        <div className='ml-2' style={{ fontWeight: '600' }}>min</div>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )
                            })}
                        </div>
                    } */}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default SFGoalDialog;
